export default "__VITE_ASSET__CfZeNgST__"